import { render, staticRenderFns } from "./UpdateThreadPage.vue?vue&type=template&id=658caeda&scoped=true"
import script from "./UpdateThreadPage.vue?vue&type=script&lang=js"
export * from "./UpdateThreadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658caeda",
  null
  
)

export default component.exports